// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__4TpxA","inputWrap":"CustomTip_inputWrap__3zEds"};